import { Box, Modal } from "@mui/material";
import React, { useState, useEffect } from "react";

const style = {
  position: "absolute" as "absolute",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  left: "50%",
  top: "50%",
  flex: "1",
  transform: "translate(-50%, -50%)",
  maxWidth: 400,
  minWidth: 350,
  maxHeight: "450px",
  bgcolor: "bgColor.white",
  boxShadow: 24,
  borderRadius: "15px",
  minHeight:"500px",
  p: 2,
};

const keyframes = `
  @keyframes slideIn {
    from {
      transform: translate(-50%, 100%);
    }
    to {
      transform: translate(-50%, -50%);
    }
  }
  @keyframes slideOut {
    from {
      transform: translate(-50%, -50%);
    }
    to {
      transform: translate(-50%, 150%);
    }
  }
`;

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  children: JSX.Element[] | JSX.Element;
}

export default function ModalLayout({ open, setOpen, children }: Props) {
  const [showModal, setShowModal] = useState(open);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (open) {
      setShowModal(true);
      setIsClosing(false);
    } else {
      setIsClosing(true);
      setTimeout(() => {
        setShowModal(false);
        setIsClosing(false);
      }, 150); // Match the animation duration
    }
  }, [open]);

  return (
    <Modal
      open={showModal}
      // onClose={() => setOpen(false)}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        direction: "rtl",
      }}
    >
      <Box
        sx={{
          ...style,
          animation: `${
            isClosing ? "slideOut 0.2s ease-out" : "slideIn 0.2s ease-out"
          }`,
          overflow: "scroll",
        }}
      >
        <style>{keyframes}</style>
        {children}
      </Box>
    </Modal>
  );
}
